<template>
    <div id="app">
        <div
            class="app-main"
            :class="routeName"
            :style="{
                backgroundColor: ind[industry].bgcolor || '#fff',
            }"
        >
            <!-- 登录页面 -->
            <template v-if="isFullScreen">
                <router-view class="main"></router-view>
            </template>
            <!-- 选择角色页面 -->
            <template v-else-if="isNoSidebar">
                <layout-Header></layout-Header>
                <div class="wrapper no-sidebar">
                    <div
                        id="container"
                        :class="{container: false, select: sidebarFlag}"
                    >
                        <router-view class="main"></router-view>
                    </div>
                </div>
            </template>
            <template v-else-if="isNoContainer">
                <layout-Header></layout-Header>
                <router-view class="main"></router-view>
            </template>
            <!-- 功能页面 -->
            <template v-else>
                <layout-Header></layout-Header>
                <div class="bg-slide"></div>
                <div
                    class="wrapper"
                    :style="{
                        backgroundColor: ind[industry].bgcolor || '#fff',
                    }"
                >
                    <layout-Sidebar
                        v-if="!sidebarFlag"
                        class="sidebar"
                        :style="{
                            backgroundColor: ind[industry].bgcolor
                                ? '#fff'
                                : 'inherit',
                        }"
                    >
                    </layout-Sidebar>
                    <div
                        id="container"
                        :class="{container: true, select: sidebarFlag}"
                    >
                        <router-view class="main"></router-view>
                        <wise-guide v-if="isLawyer"></wise-guide>
                    </div>
                </div>
            </template>

            <!-- 预览环境标识 -->
            <div v-if="isPreview" class="preview-bar">
                预览机环境<span @click="clearCookie">清除</span>
            </div>
        </div>
        <authentice-dialog
            v-if="isShowAuthentice"
            :show="isShowAuthentice"
            :info="authenticeDialogInfo"
            @handleModalClose="isShowAuthentice = false"
        ></authentice-dialog>
        <vip-authorize-modal
            :show="isAuthorizeShow"
            :authorized="true"
            @cancel="isAuthorizeShow = false"
        />
        <free-vip-dialog
            v-if="freeVipDialogType"
            :type="freeVipDialogType"
            @cancel="freeVipDialogType = ''"
            @changeType="type => freeVipDialogType = type"
            @showAuthSuccessModal="isAuthorizeShow = true"
        ></free-vip-dialog>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import Header from './components/law-header.vue';
import Sidebar from './components/sidebar';
import {lawyerNotCertifiedIntercept} from '@/utils/law/roleIntercept';
import AuthenticeDialog from '@/components/law-bjh-tip/authentice-dialog';
import eventBus from '@/mixins/eventBus';
import wiseGuide from '@/components/wiseGuide';
import FreeVipDialog from '@/components/vip/free-vip-dialog';
import VipAuthorizeModal from '@/components/vip/vip-authorize-modal';

export default {
    name: 'App',
    mixins: [eventBus(['global_authentice', 'global_free_vip_event'])],
    components: {
        'layout-Header': Header,
        'layout-Sidebar': Sidebar,
        'authentice-dialog': AuthenticeDialog,
        'vip-authorize-modal': VipAuthorizeModal,
        'wise-guide': wiseGuide,
        'free-vip-dialog': FreeVipDialog
    },
    data() {
        return {
            industry: 'law',
            stopSevingModal: true,
            // 是否展示认证拦截弹窗
            isShowAuthentice: false,
            // 是否预览环境
            isPreview: false,
            // 免费体验会员弹窗类型
            freeVipDialogType: '',
            expireKeywords: '',
            authenticeDialogInfo: {},
            isAuthorizeShow: false,
            routeName: '' // 当前路由名称
        };
    },
    computed: {
        ...mapState({
            ind: state => state.Industry.ind,
            userInfo: state => state.lawStore.userInfoNew,
            authenticationStatus: state =>
                state.lawStore.authenticationStatus
        }),
        sidebarFlag() {
            return this.$route.meta.auth === 'out';
        },
        isFullScreen() {
            return this.$route.name === 'login';
        },
        isNoContainer() {
            return ['lawyer-info-confirm', 'claim-lawyer'].includes(this.$route.name);
        },
        isNoSidebar() {
            return ['filldata', 'introduce-bjh', 'claim-lawyer'].includes(this.$route.name);
        },
        isLawyer() {
            return this.userInfo.user_role === 0;
        }
    },
    watch: {
        authenticationStatus: {
            immediate: true,
            handler(newVal) {
                if (!newVal) {
                    return;
                }
                // user_role: -1: 没角色；0:律师；1:代理商；2:律所
                const user_role = this.userInfo.user_role;
                if (+user_role !== 0) {
                    return;
                }
                // 未完成律师认证
                if (
                    newVal < 4
                    && this.$route.path !== '/lawinfo/lawverifyguide'
                    && this.$route.path !== '/material'
                    && this.$route.path !== '/claim-lawyer'
                ) {
                    this.$router.push('/lawinfo/lawverifyguide');
                    return;
                }
                // 已完成执业认证且跳转lawverifyguide页。
                if (
                    newVal >= 4
                    && this.$route.path === '/lawinfo/lawverifyguide'
                ) {
                    this.$router.push('/lawinfo');
                }
            }
        },
        '$route'(to) {
            this.routeName = to.path.replace('/', '');
        }
    },
    methods: {
        ...mapActions({
            getBjhInfo: 'lawStore/getBjhInfo',
            getUserInfoNew: 'lawStore/getUserInfoNew',
            getAgentData: 'lawStore/getAgentData',
            getQrcodeUrl: 'lawStore/getQrcodeUrl'
        }),
        on_global_free_vip_event({payload}) {
            const {dialogType, expireKeywords} = payload;
            this.freeVipDialogType = dialogType;
            this.expireKeywords = expireKeywords;
        },
        // global_authentice事件回调
        on_global_authentice(args) {
            const {payload} = args || {};
            this.authenticeDialogInfo = payload || {};
            this.isShowAuthentice = true;
        },
        // 检查是否预览环境
        checkEnv() {
            // 有相应cookie时再打接口检查，减少无效请求
            const cookie = document.cookie || '';
            if (
                cookie.indexOf('orp_preview=1') !== -1
                && cookie.indexOf('pandora_preview=1') !== -1
            ) {
                fetch('https://wen.baidu.com/wmis/preview/currentenv', {
                    credentials: 'include',
                    mode: 'cors'
                })
                    .then(res => res.json())
                    .then(res => {
                        if (res?.data?.env === 1) {
                            this.isPreview = true;
                        }
                    });
            }
        },
        // 清除预览环境cookie，刷新页面
        clearCookie() {
            fetch('https://wen.baidu.com/wmis/preview/clearCookie', {
                credentials: 'include',
                mode: 'cors'
            }).then(() => {
                window.location.reload();
            });
        }
    },
    created() {
        const {authToken} = this.$route.query || {};
        if (authToken) {
            return;
        }
        this.getUserInfoNew();
        this.getBjhInfo();
        this.getAgentData();
        this.getQrcodeUrl();
        if (
            location.href.includes('bjhEdit')
            || location.href.includes('bjhContent')
        ) {
            this.$router.push({name: 'lawinfo'});
        }
        this.$router.beforeEach((to, from, next) => {
            // user_role:0:律师；1:代理商；2:律所
            const user_role = this.userInfo.user_role;
            if (+user_role !== 0) {
                next();
                return;
            }
            lawyerNotCertifiedIntercept(to, from, next);
        });
        this.checkEnv();
    },
    mounted() {
        if (window.sessionStorage.getItem('isModal')) {
            this.stopSevingModal = false;
        }
    }
};
</script>

<style lang="less">
@import "./assets/css/baseGlobal.less";
</style>
<style scoped lang="less">
@import "./assets/css/base.less";

// 法律单独配置的css
.app-main {
    position: relative;
    height: auto;
    min-height: 100%;
    margin: 0 auto;

    &.roleSet {
        background: #e9f2ff url("https://lvlin-base.cdn.bcebos.com/fe-saas/common/role-set-bg-new.png") no-repeat top center / 1440px 291px !important;

        .bg-slide {
            background: #e9f2ff !important;
        }

        .law-header {
            border-bottom: none;
            background: transparent;
        }

        .wrapper {
            background: transparent !important;
        }
    }

    .wrapper {
        width: 1338px;
        display: flex;
        margin: 24px auto 0;
        .clearfix();

        .select {
            width: 100%;
            padding: 48px;
        }

        .sidebar {
            width: 186px;
            padding-top: 16px;
            max-height: calc(100vh - 112px);
            border-right: 0;
            box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
            border-radius: 8px;
            box-sizing: border-box;
            background: #fff;

            /deep/ .item {
                // width 200px
                margin-left: 24px;
            }

            /deep/ .icon {
                margin-right: 8px;
            }

            /deep/ .sub {
                padding-left: 24px;
            }

            /deep/ .router-link-active {
                color: #05f;
                font-weight: 600;
            }
        }

        .container {
            padding: 0;
            width: 1128px;
            min-height: calc(100vh - 104px);
            box-sizing: border-box;
            margin-left: 24px;
            .clearfix();

            .main {
                height: calc(100vh - 112px);
                .clearfix();

                min-height: 400px;
                overflow: auto;

                &::-webkit-scrollbar {
                    width: 0;
                    opacity: 0;
                    -webkit-overflow-scrolling: touch;
                }
            }
        }

        /deep/ .footer-main {
            width: 960px;
        }
        // 无侧边栏样式
        &.no-sidebar {
            width: 100%;
            display: block;
        }
    }

    .bg-slide {
        width: calc(((100vw - 1200px) / 2));
        min-height: 100vh;
        background: rgb(246, 247, 250);
        position: fixed;
        top: 0;
    }

    .lawfooter {
        width: 1032px;
    }

    .preview-bar {
        position: absolute;
        top: 0;
        left: 0;
        height: 26px;
        padding: 0 8px;
        border-radius: 0 0 8px 0;
        font-size: 14px;
        font-weight: 700;
        color: #fff;
        background-color: rgba(255, 0, 0, .5);
        z-index: 999;
        display: flex;
        align-items: center;

        & > span {
            cursor: pointer;
            font-size: 12px;
            padding: 2px;
            font-weight: 400;
            margin-left: 8px;
            color: #000;
            line-height: 1;
            background-color: #fff;
            border-radius: 4px;
        }
    }
}
</style>
